<div class="template3 bonus-info">
    <div  *ngIf="displayBusinessInfoForm" [class.hideValidation]="validationMessageInitialHide">
        <json-schema-form [widgets]="customWidgets" [framework]="selectedFrameWork" [form]="jsonFormObject" [options]="jsonFormOptions" (onChanges)="onChanges($event)"
            (onSubmit)="saveBusinessInfo($event)" (valueChanges)="changeInputValue($event)">
        </json-schema-form>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/enrollment/business-info.component.html